module.exports = __webpack_public_path__ + "img/w3_user_grey.4806b971.png";